import React, { Component } from 'react';
import { FINANCIALDATA } from '../../../constants';
class FinancialList extends Component {
    handleFinancialScoreChange = (event, id) => {
        this.props.financialDataCallback(FINANCIALDATA, event, id)
    }
    render() {
        if (this.props.data) {
            return (
                this.props.data.map(p => {
                    return (
                        < tr key={p.id} >
                            <td key={p.id + 'td'}>
                                {p.name}
                            </td>
                            <td key={p.id + 'td1'}>{p.currentScore}</td>
                            <td>
                                <select className="form-control" id="scoreSelect" onChange={(event) => this.handleFinancialScoreChange(event, p.id)}>
                                    <option value=''>Select</option>
                                    {p.scores.map(element => {
                                        let tempValue;
                                        if (p.currentScore) {
                                            if ((p.currentScore).toString() === (element.value).toString()) {
                                                tempValue = element.value
                                                return (
                                                    <option key={p.id + Math.random()} selected={tempValue} value={tempValue}>{element.label} {'(' + element.value + ')'}</option>
                                                )
                                            } else {
                                                return (
                                                    <option key={p.id + Math.random()} value={element.value}>{element.label} {'(' + element.value + ')'}</option>
                                                )
                                            }
                                        } else {
                                            // tempValue = p.currentScore
                                            return (
                                                <option key={p.id + Math.random()} value={element.value}>{element.label} {'(' + element.value + ')'}</option>
                                            )
                                        }

                                    })}
                                </select>
                            </td>
                            <td key={p.name + 'td1'}>
                                <span>{p.weight}</span>
                            </td>
                        </tr >
                    )
                })
            )
        }
    }
}
export default FinancialList;